import React from "react";
import { logo_white } from "../../Assets";
import AccountMenu from "../../Components/GeneralComponents/AccountMenu";
import { useContent } from "../../hooks/useContent";
import { NavLink } from "react-router-dom";

export default function AppHeader() {
  const { pageHeading } = useContent();

  return (
    <header className="header shadow-sm">
      <div className="container d-flex justify-content-between align-items-center py-3">
        <NavLink to="/">
          <img
            src={logo_white}
            alt="Logo"
            className="app-logo cursor-pointer"
          />
        </NavLink>
        <h2 className="mb-0 fw-bold">{pageHeading}</h2>
        <div className="text-secondary small">
          <AccountMenu />
        </div>
      </div>
    </header>
  );
}
